import api from './api';
import type { AttendanceRecord } from '../types';

/**
 * Attendance Register API Service
 */
export const attendanceService = {
  /**
   * Queries daily class register listings for a specific school day
   */
  getDailyRegister: async (classId: number, date: string): Promise<AttendanceRecord[]> => {
    const response = await api.get(`/attendance/class/${classId}/date/${date}`);
    return response.data.success ? response.data.data : [];
  },

  /**
   * Records completed daily attendance grids in bulk
   */
  bulkSaveRegister: async (
    classId: number, 
    date: string, 
    records: { pupil_id: number; status: 'P' | 'A' | 'L' | 'E'; remarks?: string }[]
  ): Promise<boolean> => {
    const response = await api.post('/attendance/bulk', {
      class_id: classId,
      date,
      records
    });
    return response.data.success;
  }
};

export default attendanceService;
